__turbopack_context__.v({
  "aaasCaretIcon": "PricingPageContent-module__ZpBcTa__aaasCaretIcon",
  "aaasCaretOpen": "PricingPageContent-module__ZpBcTa__aaasCaretOpen",
  "aaasCaretWrap": "PricingPageContent-module__ZpBcTa__aaasCaretWrap",
  "aaasPanel": "PricingPageContent-module__ZpBcTa__aaasPanel",
  "aaasSection": "PricingPageContent-module__ZpBcTa__aaasSection",
  "aaasSummary": "PricingPageContent-module__ZpBcTa__aaasSummary",
  "aaasTrigger": "PricingPageContent-module__ZpBcTa__aaasTrigger",
  "aaasTriggerHeading": "PricingPageContent-module__ZpBcTa__aaasTriggerHeading",
  "aaasTriggerTitle": "PricingPageContent-module__ZpBcTa__aaasTriggerTitle",
  "calculatorSection": "PricingPageContent-module__ZpBcTa__calculatorSection",
  "comparisonColumn": "PricingPageContent-module__ZpBcTa__comparisonColumn",
  "comparisonGrid": "PricingPageContent-module__ZpBcTa__comparisonGrid",
  "comparisonIcon": "PricingPageContent-module__ZpBcTa__comparisonIcon",
  "comparisonIconThem": "PricingPageContent-module__ZpBcTa__comparisonIconThem",
  "comparisonIconUs": "PricingPageContent-module__ZpBcTa__comparisonIconUs",
  "comparisonItem": "PricingPageContent-module__ZpBcTa__comparisonItem",
  "comparisonList": "PricingPageContent-module__ZpBcTa__comparisonList",
  "comparisonTextThem": "PricingPageContent-module__ZpBcTa__comparisonTextThem",
  "comparisonTextUs": "PricingPageContent-module__ZpBcTa__comparisonTextUs",
  "comparisonTitle": "PricingPageContent-module__ZpBcTa__comparisonTitle",
  "container": "PricingPageContent-module__ZpBcTa__container",
  "ctaRow": "PricingPageContent-module__ZpBcTa__ctaRow",
  "deliverables": "PricingPageContent-module__ZpBcTa__deliverables",
  "deliverablesTitle": "PricingPageContent-module__ZpBcTa__deliverablesTitle",
  "heroBleed": "PricingPageContent-module__ZpBcTa__heroBleed",
  "heroBleedContent": "PricingPageContent-module__ZpBcTa__heroBleedContent",
  "heroBleedImage": "PricingPageContent-module__ZpBcTa__heroBleedImage",
  "heroBleedOverlay": "PricingPageContent-module__ZpBcTa__heroBleedOverlay",
  "heroTitle": "PricingPageContent-module__ZpBcTa__heroTitle",
  "heroTitleClosing": "PricingPageContent-module__ZpBcTa__heroTitleClosing",
  "newBadge": "PricingPageContent-module__ZpBcTa__newBadge" + " " + __turbopack_context__.i(262643)["brandchip"],
  "packageCard": "PricingPageContent-module__ZpBcTa__packageCard",
  "packageCta": "PricingPageContent-module__ZpBcTa__packageCta",
  "packageDescription": "PricingPageContent-module__ZpBcTa__packageDescription",
  "packageDuration": "PricingPageContent-module__ZpBcTa__packageDuration",
  "packageHeader": "PricingPageContent-module__ZpBcTa__packageHeader",
  "packageList": "PricingPageContent-module__ZpBcTa__packageList",
  "packagePrice": "PricingPageContent-module__ZpBcTa__packagePrice",
  "packageProof": "PricingPageContent-module__ZpBcTa__packageProof",
  "packagesHeading": "PricingPageContent-module__ZpBcTa__packagesHeading",
  "packagesSection": "PricingPageContent-module__ZpBcTa__packagesSection",
  "page": "PricingPageContent-module__ZpBcTa__page",
  "testimonial": "PricingPageContent-module__ZpBcTa__testimonial",
  "testimonialContainer": "PricingPageContent-module__ZpBcTa__testimonialContainer",
  "testimonialInner": "PricingPageContent-module__ZpBcTa__testimonialInner",
  "testimonialQuote": "PricingPageContent-module__ZpBcTa__testimonialQuote",
  "value": "PricingPageContent-module__ZpBcTa__value",
});
